import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import _ from 'lodash';
import SauceyLogo from 'images/saucey.svg';
import SubstitutionsOverview from './overview';
import SubstitutionDetail from './detail';
import SubstitutionsSuccess from './success';
import {
  updateStatus,
  removeOutOfStockItem,
  cancelUpdate,
  confirmUpdate
} from './actions';
import { trackNow } from 'shared/models/analytic';

class SubstitutionsPage extends React.Component {
  componentDidMount() {
    if (!this.props.status) {
      trackNow('Substitution Page Viewed');
      this.props.updateStatus('Viewing');
    }
  }

  remove(item) {
    trackNow('Substitution Item Removed', { sku: item.sku_id });
    return this.props.removeOutOfStockItem(item);
  }

  cancel(item) {
    trackNow('Substitution Item Canceled', { sku: item.sku_id });
    return this.props.cancelUpdate(item);
  }

  save() {
    trackNow('Substitution Order Updated');
    return this.props.confirmUpdate();
  }

  render() {
    const parentMatch = this.props.match;
    const user = this.props.user;
    const order = this.props.order || {};
    const updates = this.props.updates;
    const items = (order.products || []).filter(p => p.soldout);
    const loadingStates = this.props.loadingStates || {};
    const errors = this.props.errors || {};

    return (
      <div className="substitutions">
        <div className="substitutions__header text-center">
          <a href="/" className="substitutions__logo-container">
            <img className="substitutions__logo" src={SauceyLogo} />
          </a>
        </div>

        <Route
          exact
          path="/substitution/:order_id"
          render={() =>
            this.props.status === 'Done' ? (
              <SubstitutionsSuccess user={user} />
            ) : (
              <SubstitutionsOverview
                user={user}
                baseUrl={parentMatch.url}
                contactNumber={this.props.contactNumber}
                removeItem={item => this.remove(item)}
                cancelUpdate={item => this.cancel(item)}
                confirmUpdate={() => this.save()}
                items={items}
                updates={updates}
                loadingStates={loadingStates}
                errors={errors}
              />
            )}
        />

        <Route
          path="/substitution/:order_id/:sku_id"
          render={({ match }) => {
            const item = _.find(items, p => p.sku_id === match.params.sku_id);
            const currentSubstitution = (updates[item.sku_id] || {}).added;
            return (
              <SubstitutionDetail
                item={item}
                baseUrl={parentMatch.url}
                currentSubstitution={currentSubstitution}
              />
            );
          }}
        />
      </div>
    );
  }
}

const ConnectedSubstitutionsPage = connect(
  state => ({
    ...state.substitutions,
    user: state.login.user
  }),
  { updateStatus, removeOutOfStockItem, cancelUpdate, confirmUpdate }
)(SubstitutionsPage);

export default ConnectedSubstitutionsPage;
